import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr";
import { Modal } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';

import { logout } from "../../../auth/authActions";
import {
    // GettodosPdd, 
    getDataTdsRevendas
    , GetPdd
    , PegaStatusPedido
    , PegaItensPedido
    , enviaOrderRegistros
    // , PegapayloadPedido
} from "./orderActions";
import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

class Order extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []

            , arrayEnviarTodos_cod_pedido_app: []
            , arrayEnviarTodos_cod_status_pedido: []

            , arrayEnviar_cod_pedido_app: []
            , arrayEnviar_cod_status_pedido: []
            , isModalOpen: 0
            , SelCodCet: ""
            , dataIni: this.formatDateNormal(new Date(Date.now()), 'pt-br')
            , dataFim: this.formatDateNormal(new Date(Date.now()), 'pt-br')

            , lstSelEnvOrder: []
            // , LstSelOrder: []
            , NroPddSel: ""
            , MsgModal2: ""
        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            //   this.buscainformacoesFiltro(this.props.codPuxada);
            // this.props.GettodosPdd(
            //     this.props.codPuxada        
            // , "1900-01-01"           //DatIni
            // , "2999-01-01"           //DatFim
            // , 0                     //CodCet);
            // )
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action",
                text: "",
                className: "action",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "action1",
                text: "",
                className: "action1",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button variant="success"
                                name="isGoing"
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                style={{ fontSize: "10px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
                                onClick={this.BscStatusPdd.bind(this, record, index)}
                                title="Informações do Status"
                            > S
                            </button >
                        </Fragment >
                    );
                }
            },
            {
                key: "action2",
                text: "",
                className: "action2",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button
                                name="isGoing1"
                                type="button"
                                className="btn btn-outline-success btn-sm"
                                style={{ fontSize: "10px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
                                onClick={this.BscItensPdd.bind(this, record, index)}
                                title="Informações dos itens"
                            > I
                            </button >
                        </Fragment>
                    );
                }
            },
            // {
            //     key: "action3",
            //     text: " ",
            //     className: "action3",
            //     sortable: false,
            //     cell: (record, index) => {
            //         return (
            //             <Fragment>
            //                 <button
            //                     name="isGoing2"
            //                     type="button"
            //                     className="btn btn-outline-success btn-sm"
            //                     style={{ fontSize: "10px", fontFamily: "Barlow", fontStyle: "italic", fontWeight: "Bold" }}
            //                     onClick={this.BscPayload.bind(this, record, index)}
            //                     title="Payload do Pedido"
            //                 > P
            //                 </button >
            //             </Fragment>
            //         );
            //     }
            // },

            {
                key: "cod_pedido_app",
                text: "Cód.Pdd",
                className: "cod_pedido_app",
                align: "left",
                sortable: true
            },
            {
                key: "dat_pedido",
                text: "Data Pdd",
                className: "dat_pedido",
                align: "left",
                sortable: true,
                width: 160
            }, {
                key: "cod_pdv",
                text: "Cód.Cet",
                className: "cod_pdv",
                align: "left",
                sortable: true,

            },
            {
                key: "name",
                text: "Nome",
                className: "name",
                align: "left",
                sortable: true,
                width: 250,
                fontSize: "10px"
            },
            {
                key: "vlr_total_pedido",
                text: "Valor",
                className: "vlr_total_pedido",
                align: "right",
                sortable: true
            },
            {
                key: "totSkus_pedido",
                text: "Tot Skus",
                className: "totSkus_pedido",
                sortable: true,
                align: "left",

            }, {
                key: "cod_condicao_pagamento",
                text: "Cód Prz",
                className: "cod_condicao_pagamento",
                sortable: true,
                align: "left"
            },
            {
                key: "cod_status_pedido",
                text: "Cód Sts",
                className: "cod_status_pedido",
                sortable: true,
                align: "left",

            },
            {
                key: "dsc_status_pedido",
                text: "Dsc. Status",
                className: "dsc_status_pedido",
                sortable: true,
                align: "left"
            },
            {
                key: "dat_entrega",
                text: "Data Entrega",
                className: "dat_entrega",
                sortable: true,
                align: "left",
                width: 140
            },
            {
                key: "ind_excluido",
                text: "Exc",
                className: "ind_excluido",
                sortable: true,
                align: "left",

            },
            {
                key: "id_pedido_app",
                text: "Cód Pdd App",
                className: "id_pedido_app",
                sortable: true,
                align: "left"
            },
            {
                key: "Cod_Pedido_Avante",
                text: "Cód Pdd Avt",
                className: "Cod_Pedido_Avante",
                sortable: true,
                align: "left",

            },

        ];

        this.config = {
            key_column: 'cod_pedido_app',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "Order",

            language: {
                loading: "True",
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
            }

        }

        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>
                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>
                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.selecionaCheck = this.selecionaCheck.bind(this);

        // this.SetCarreganaLista = this.SetCarreganaLista.bind(this);

        this.setLimpaFiltro = this.setLimpaFiltro.bind(this);
        this.setEnviaFiltro = this.setEnviaFiltro.bind(this);

        this.OpenModalParam = this.OpenModalParam.bind(this);
        this.FecharModalParam = this.FecharModalParam.bind(this);

        this.setPuxada = this.setPuxada.bind(this);

        this.PopulartodosArrayEnviar = this.PopulartodosArrayEnviar.bind(this);
        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);

        this.setDataIni = this.setDataIni.bind(this);
        this.setDataFim = this.setDataFim.bind(this);
        this.setCodCet = this.setCodCet.bind(this);
        this.formatDateNormal = this.formatDateNormal.bind(this);
        this.setAdcLst = this.setAdcLst.bind(this);
        this.BscStatusPdd = this.BscStatusPdd.bind(this);
        this.BscItensPdd = this.BscItensPdd.bind(this);
        this.PopulararrayEnviarTodos = this.PopulararrayEnviarTodos.bind(this);

        this.ExportarArq = this.ExportarArq.bind(this);
        // this.BscPayload = this.BscPayload.bind(this);
    }

    ExportarArq(xml, dsc_status) {
        let downloadLink, dataType = 'application/vnd.ms-excel';

        let tableHtml = xml;

        // Specify file name
        let filename = "Arq_" + this.state.NroPddSel + "_" + dsc_status + ".xml";
        // Create download link element
        downloadLink = document.createElement("a");
        if (navigator.msSaveOrOpenBlob) {
            let blob = new Blob(['\ufeff', tableHtml], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = 'data:' + dataType + ', ' + tableHtml;
            // Setting the file name
            downloadLink.download = filename;
            //triggering the function
            downloadLink.click();
        }


    }

    setPuxada(e) {

        this.setState({
            SelPuxada: e.target.value
            ,booLerRecords: false
        });

        if (e.target.value === null || Number(e.target.value) === 0) {
            toastr.warning("Atenção Selecione uma Revenda")

        }
        else {
            //   this.buscainformacoesFiltro(e.target.value);
            // this.props.GettodosPdd(
            //     e.target.value   
            // , "1900-01-01"           //DatIni
            // , "2999-01-01"           //DatFim
            // , 0                     //CodCet);
            // ) 

        }



    }

    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2_cod_pedido_app = [];
        const array2_cod_status_pedido = [];

        let Existe = [{}];

        Existe =
            (
                this.state.arrayMarcados
                    .filter((a) => a.productId === registro.cod_pedido_app &&
                        a.cod_status_pedido === registro.cod_status_pedido
                    )
            )

        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)
            this.state.arrayEnviar_cod_pedido_app.push(registro.cod_pedido_app);
            this.state.arrayEnviar_cod_status_pedido.push(registro.cod_status_pedido);
        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].productId === registro.cod_pedido_app &&
                    this.state.arrayMarcados[i].cod_status_pedido === registro.cod_status_pedido) { }
                else {
                    array1.push(this.state.arrayMarcados[i]);
                    array2_cod_pedido_app.push(this.state.arrayMarcados[i].productId);
                    array2_cod_status_pedido.push(this.state.arrayMarcados[i].cod_status_pedido);
                }
            }

            this.setState({
                arrayEnviar_cod_pedido_app: array2_cod_pedido_app
                , arrayEnviar_cod_status_pedido: array2_cod_status_pedido
                , arrayMarcados: array1
            });

        }

    }

    ExportaSelecao() {

        if (this.state.arrayMarcados.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(5)
            this.props.enviaOrderRegistros(
                this.state.arrayEnviar_cod_pedido_app
                , this.state.arrayEnviar_cod_status_pedido
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario
                , this.state.dataIni            //DatIni
                , this.state.dataFim            //DatFim
                , (this.state.SelCodCet === "" || this.state.SelCodCet === undefined ? 0 : this.state.SelCodCet)       //CodCet

            )

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_cod_pedido_app: []
                    , arrayEnviar_cod_status_pedido: []
                    , isModalOpen: 0
                    // , lstSelEnvOrder: this.props.LstOrder || []
                });
            }, 4000);

        }


    }

    PopulararrayEnviarTodos() {

        this.setState({
            arrayEnviarTodos_cod_pedido_app: []
            , arrayEnviarTodos_cod_status_pedido: []
        });
        if (this.state.lstSelEnvOrder !== undefined && this.state.lstSelEnvOrder !== null) {
            for (let i = 0, l = this.state.lstSelEnvOrder.length; i < l; i++) {
                this.state.arrayEnviarTodos_cod_pedido_app.push(this.state.lstSelEnvOrder[i].cod_pedido_app);
                this.state.arrayEnviarTodos_cod_status_pedido.push(this.state.lstSelEnvOrder[i].cod_status_pedido);
            }
        }
    }

    ExportaTodos() {

        this.PopulararrayEnviarTodos();

        if (this.state.arrayEnviarTodos_cod_pedido_app.length === 0) {
            toastr.warning("Não há Order a enviar !!!!")
        }
        else {

            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(5)
            this.props.enviaOrderRegistros(
                this.state.arrayEnviarTodos_cod_pedido_app
                , this.state.arrayEnviarTodos_cod_status_pedido
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario
                , this.state.dataIni            //DatIni
                , this.state.dataFim            //DatFim
                , (this.state.SelCodCet === "" || this.state.SelCodCet === undefined ? 0 : this.state.SelCodCet)       //CodCet

            )

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviarTodos_cod_pedido_app: []
                    , arrayEnviarTodos_cod_status_pedido: []
                    , isModalOpen: 0

                });
            }, 4000);
        }
    }

    setCodCet(e) {
        this.setState({
            SelCodCet: e.target.value
        });
    }
    setDataIni(e) {
        this.setState({
            dataIni: e.target.value
        });
    }
    setDataFim(e) {
        this.setState({
            dataFim: e.target.value
        });
    }

    setAdcLst() {

        toastr.warning("Buscando informações...");
        let booPodeTrazer = true;
        if (this.state.dataIni === "") {
            toastr.warning("Intervalo Data Marcada data inicial não selecionada");
            booPodeTrazer = false;
        }
        if (this.state.dataFim === "" && booPodeTrazer === true) {
            toastr.warning("Intervalo Data Marcada data final não selecionada");
            booPodeTrazer = false;
        }
        if ((this.state.dataIni < "2022-01-01" || this.state.dataFim > "2099-01-01") && booPodeTrazer === true) {
            toastr.warning("Atenção Data inicial ou Data Final Inválida");
            booPodeTrazer = false;
        }
        if (this.state.dataFim < this.state.dataIni && booPodeTrazer === true) {
            toastr.warning("Atenção Data Final menor que o Data Inicial");
            booPodeTrazer = false;
        }
        if (Number.isInteger(Number.parseInt(this.state.SelCodCet)) === false
            && this.state.SelCodCet !== ""
            && booPodeTrazer === true
        ) {
            toastr.warning("Atenção Código do Cliente não é Numérico");
            booPodeTrazer = false;
        }
        if (booPodeTrazer === true) {
            this.props.GetPdd(
                (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
                , this.state.dataIni            //DatIni
                , this.state.dataFim            //DatFim
                , (this.state.SelCodCet === "" || this.state.SelCodCet === undefined ? 0 : this.state.SelCodCet)       //CodCet
            );
            // if (this.props.LstOrder.length === 0) {
            //     toastr.warning("Dados não encontrados nos filtros informados!!!")
            // }
            //    this.SetCarreganaLista();
        }
    }

    // buscainformacoesFiltro(bifCodPuxada) {

    //     // this.props.GetCustumerVnd(bifCodPuxada);

    // }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0 })

    OpenModalParam(qualfiltro) {

        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (Number(this.state.SelPuxada) === 0 || this.state.SelPuxada === undefined) {
                toastr.warning("Atenção não selecionou uma Revenda !!!")
            }
            else {
                this.openModal(qualfiltro);
            }
        }
        else {
            if (qualfiltro === 1) {
            }
            this.openModal(qualfiltro);
        };

    }

    FecharModalParam() {
        this.closeModal();
    }

    BscStatusPdd = (registro, record, index) => {
        this.props.PegaStatusPedido(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            , registro.cod_pedido_app       //cod_pedido_app
        );
        this.setState({
            NroPddSel: registro.cod_pedido_app + "  -  Cód Cet: " + registro.cod_pdv + "   Nome: " + registro.name + "   Vr.Total: " + registro.vlr_total_pedido
        });
        this.OpenModalParam(2);
    }

    BscItensPdd = (registro, record, index) => {

        this.props.PegaItensPedido(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            , registro.cod_pedido_app       //cod_pedido_app
        );
        this.setState({
            NroPddSel: registro.cod_pedido_app + "  -  Cód Cet: " + registro.cod_pdv + "   Nome: " + registro.name + "   Vr.Total: " + registro.vlr_total_pedido
        });
        this.OpenModalParam(3);
    }

    // BscPayload = (registro, record, index) => {

    //     this.props.PegapayloadPedido(
    //         (this.props.codPuxada === undefined || this.props.codPuxada === null
    //             ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
    //         , registro.cod_pedido_app       //cod_pedido_app
    //     );
    //     this.OpenModalParam(4);
    // }

    setLimpaFiltro() {

        this.props.GetPdd(
            (this.props.codPuxada === undefined || this.props.codPuxada === null
                ? this.state.SelPuxada : this.props.codPuxada) //CodPuxada
            , "1900-01-01"           //DatIni
            , "1900-01-01"           //DatFim
            , 0       //CodCet
        );

        this.setState({

            SelCodCet: ""
            // , LstSelOrder: []
            , arrayEnviarTodos_cod_pedido_app: []
            , arrayEnviarTodos_cod_status_pedido: []
            , arrayEnviar_cod_pedido_app: []
            , arrayEnviar_cod_status_pedido: []

        });
    }

    setEnviaFiltro() {

        this.setState({
            // lstSelEnvOrder: this.state.LstSelOrder || []
            lstSelEnvOrder: this.props.LstOrder || []
        });
        this.FecharModalParam();
    }

    //     SetCarreganaLista() {

    //         // if (this.props.LstOrder.length === 0) {
    //         //     toastr.warning("Dados não encontrados nos filtros informados!!!")
    //         // }
    //         // console.log("this.state.SelCodCet: " + this.state.SelCodCet)
    //         // console.log("this.state.dataIni: " + this.state.dataIni)
    //         // console.log("this.state.dataFim: " + this.state.dataFim)

    // console.log("this.props.LstOrder.length 1: " + this.props.LstOrder.length)

    //         let arraylstAtual = this.state.LstSelOrder || [];
    //        // const arraylstTodosPdd = this.props.LstTodosOrder || [];

    //         let arraylstDoFiltro = this.props.LstOrder || [];

    //         //Carrega com o Filtro
    //         // if (this.state.SelCodCet === 0 || this.state.SelCodCet === "")
    //         // {
    //         //     arraylstDoFiltro = arraylstTodosPdd
    //         //         .filter((a) => (  this.state.dataIni >= this.formatDateNormal(Date(a.dat_pedido),'pt-br') &&
    //         //                         this.state.dataFim <= this.formatDateNormal(Date(a.dat_pedido),'pt-br'))
    //         //         )
    //         // }
    //         // else{
    //         //     arraylstDoFiltro = arraylstTodosPdd
    //         //         .filter((a) => Number(a.cod_pdv) === Number(this.state.SelCodCet) 
    //         //                     && (this.state.dataIni >= this.formatDateNormal(Date(a.dat_pedido),'pt-br') &&
    //         //                     this.state.dataFim <= this.formatDateNormal(Date(a.dat_pedido),'pt-br')  )
    //         //         )

    //         // }


    //         //Carrega arraylstAtual
    //         for (let i = 0, l = arraylstDoFiltro.length; i < l; i++) {

    //             let Existe = []

    //             Existe =
    //                 (
    //                     arraylstAtual.filter((a) => a.cod_pedido_app === arraylstDoFiltro[i].cod_pedido_app)
    //                 )

    //             if (Existe.length === 0) {
    //                 arraylstAtual.push(arraylstDoFiltro[i])
    //             }

    //         }

    //         this.setState({
    //             LstSelOrder: arraylstAtual
    //         });

    //   }

    PopulartodosArrayEnviar() {

        this.setState({
            arrayEnviarTodos_cod_pedido_app: []
            , arrayEnviarTodos_cod_status_pedido: []
        });
        if (this.state.lstSelEnvOrder !== undefined && this.state.lstSelEnvOrder !== null) {
            for (let i = 0, l = this.state.lstSelEnvOrder.length; i < l; i++) {
                this.state.arrayEnviarTodos_cod_pedido_app.push(this.state.lstSelEnvOrder[i].cod_pedido_app);
                this.state.arrayEnviarTodos_cod_status_pedido.push(this.state.lstSelEnvOrder[i].cod_status_pedido);
            }
        }

    }
    formatDateNormal(datatrab, formato) {

        if (datatrab !== null) {
            if (formato === 'pt-br') {
                return String(
                    datatrab.getFullYear()
                    + '-'
                    + (datatrab.getMonth() + 1 > 9 ? datatrab.getMonth() + 1 : '0' + (datatrab.getMonth() + 1))
                    + '-'
                    + (datatrab.getDate() > 9 ? datatrab.getDate() : '0' + (datatrab.getDate()))
                )

            }
        }
    }

    render() {

        const Listapuxadas = this.props.redListaTdsRevendas || [];
        const RegStatus = this.props.LstSttus || [];
        const RegItens = this.props.Lstitens || [];
        // const RegPayLoad = this.props.LstPayLoad || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Order</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="0">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="form-control">
                    <div className="row">
                        <div className="col-md-4" >
                            <button type="button"
                                style={{ fontSize: "18px", backgroundColor: "#e8f7d5", border: "0" }}
                                data-toggle="tooltip"
                                title="Busca Informações para Filtro do Grid"
                                onClick={() => { this.OpenModalParam(1) }}
                            >
                                <i className="fa fa-filter " aria-hidden="true"></i>
                            </button>
                            <label style={{ color: "#77b935" }}> &nbsp; &nbsp;Informe os Filtros </label>
                        </div>
                    </div>
                </div>
                <br />

                <div>
                    <ReactDatatable
                        config={this.config}
                        records={this.props.LstOrder || []}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    />
                </div>

                {/* Filtro */}
                <Modal size="lg" show={(this.state.isModalOpen === 1 ? true : false)}
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informaçoes do Filtro para o Grid Order
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.setLimpaFiltro}
                            >Limpa Filtros
                            </button>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.setEnviaFiltro}
                            >Envia Filtro
                            </button>

                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="button"
                                style={{ background: "#77b935" }}
                                className="btn btn-secondary"
                                onClick={this.FecharModalParam}
                            >Cancela
                            </button>


                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control ">
                            {/* <div className="input-group input-group-sm mb-1"> */}

                            <div className="row">
                                <div className="col-md-4">
                                    <div className="input-group-text"
                                        style={{
                                            color: "#77b935"
                                            , fontFamily: "Barlow"
                                            , fontSize: "18px"
                                            , fontStyle: "Italic"
                                        }}
                                    >Intervalo Data
                                    </div>
                                </div>
                                <div className="col-md-2">
                                </div>
                                <div className="col-md-6">
                                    <div className="input-group-text"
                                        style={{
                                            color: "#77b935"
                                            , fontFamily: "Barlow"
                                            , fontSize: "18px"
                                            , fontStyle: "Italic"
                                        }}
                                    >Código do Cliente
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-6">
                                    <div style={{
                                        display: "flex"
                                        , color: "#77b935"
                                    }}>
                                        Início: &nbsp;
                                        <div className="LancTitDataIni">
                                            <input type="date"
                                                placeholder="dd-MM-yyyy"
                                                id="dataIni"
                                                min="2022-01-01" max="2099-01-01"
                                                value={this.state.dataIni}
                                                onChange={this.setDataIni}

                                            />
                                        </div>
                                        &nbsp; Final: &nbsp;
                                        <div className="LancTitDataFim">
                                            <input type="date"
                                                placeholder="dd-MM-yyyy"
                                                id="dataFim"
                                                min="2022-01-01" max="2099-01-01"
                                                value={this.state.dataFim}
                                                onChange={this.setDataFim}

                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <input type="text" id="CodCetIni" className="form-control"
                                        style={{ textAlign: "right" }}
                                        value={(this.state.SelCodCet)}
                                        onChange={this.setCodCet}
                                        placeholder="Código do Cliente" maxLength="10" />
                                </div>

                                <div className="col-md-2">
                                    <button type="button"
                                        style={{ fontSize: "18px", color: "#36561e" }}
                                        data-toggle="tooltip"
                                        title="Adiciona a Lista"
                                        onClick={this.setAdcLst}
                                    >
                                        <i className="fa fa-refresh " aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="form-control">
                            <div className="table "
                                style={{
                                    fontFamily: "Barlow", fontSize: "12px",
                                    color: "#36561e", height: "300px", overflow: "auto"
                                }}>

                                <table className="table table-bordered table-hover table-striped "
                                >
                                    <thead className="thead">
                                        <tr >
                                            <th>Código Pedido</th>
                                            <th>Código Cliente</th>
                                            <th>Nome</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody">
                                        {
                                            (this.props.LstOrder.length === 0 ? <span> <br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                                :
                                                this.props.LstOrder.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>{item.cod_pedido_app}</td>
                                                            <td>{item.cod_pdv}</td>
                                                            <td>{item.name}</td>
                                                        </tr>
                                                    )
                                                })
                                            
                                           
                                        )
                                        }
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>

                </Modal>

                {/* Status */}
                <Modal size="xl" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informações Status do Pedido: &nbsp;&nbsp; {this.state.NroPddSel}
                        </Modal.Title>

                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            <table className="table table-bordered  table-striped table-sm "
                                cellspacing="0" width="100%"
                                style={{
                                    fontFamily: "Barlow", fontSize: "10px",
                                    color: "#36561e", height: "100px"

                                }}
                            >
                                <thead className="thead">
                                    <tr >
                                        <th style={{ display: (this.props.TipoLicenca === 3 ? "none" : "") }} > </th>
                                        <th>Cd.Stus</th>
                                        <th>Dsc.Status</th>
                                        <th>Dt.Status</th>
                                        <th>Enviado</th>
                                        <th>Dt.Envio</th>
                                        <th>Tp.Envio</th>
                                        <th>Usu.Envio</th>
                                        <th>Cód.Retorno</th>
                                        <th>chave_log</th>
                                        <th>dsc_xml</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {(RegStatus.length === 0 ? <span> <br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                        :
                                        RegStatus.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td

                                                    >
                                                        <span
                                                            style={{
                                                                display: (this.props.TipoLicenca === 3
                                                                    || item.dsc_xml === null || item.dsc_xml === ""
                                                                    ? "none" : "")
                                                            }}
                                                            type="button"
                                                            onClick={() => { this.ExportarArq(item.dsc_xml, item.dsc_status_pedido,) }}
                                                            title="Exportar XML">
                                                            <i className="fa fa-download" aria-hidden="true"></i>
                                                        </span>
                                                    </td>
                                                    <td>{item.cod_status_pedido}</td>
                                                    <td>{item.dsc_status_pedido}</td>
                                                    <td>{item.dat_status_pedido}</td>
                                                    <td>{item.ind_enviado}</td>
                                                    <td>{item.dat_envio}</td>
                                                    <td>{item.tipo_envio}</td>
                                                    <td>{item.usr_envio}</td>
                                                    <td>{item.chave_log}</td>
                                                    <td>{item.cod_retorno}</td>
                                                    <td>{(item.dsc_xml === null ? "" : item.dsc_xml.substr(0, 50))}</td>
                                                </tr>
                                            )
                                        })
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>

                {/* itens */}
                <Modal size="xl" show={(this.state.isModalOpen === 3 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informações Itens do Pedido  &nbsp;&nbsp; {this.state.NroPddSel}
                        </Modal.Title>

                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            <table className="table table-bordered  table-striped table-sm "
                                cellspacing="0" width="100%"
                                style={{
                                    fontFamily: "Barlow", fontSize: "10px",
                                    color: "#36561e", height: "100px"

                                }}
                            >
                                <thead className="thead">
                                    <tr >
                                        {/* <th>resellerID</th> */}
                                        <th>Cód Linha</th>
                                        <th>Cód Sku</th>
                                        <th>Qtde Int.</th>
                                        <th>Qtde Und</th>
                                        <th>Vlr.Unit.</th>
                                        <th>Prc Dsct</th>
                                        <th>Vlr.Dsct</th>
                                        <th>Vlr.Total</th>
                                        <th>Cód Cmb App</th>
                                        <th>Nro Ord</th>
                                        <th>Ind Sku Corte</th>
                                        <th>Tpo Envio</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {(RegItens.length === 0 ? <span> <br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                        :
                                        RegItens.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    {/* <td>{item.resellerID}</td> */}
                                                    <td>{item.cod_linha}</td>
                                                    <td>{item.cod_sku}</td>
                                                    <td>{item.qtd_pedida_inteira}</td>
                                                    <td>{item.qtd_pedida_unidade}</td>
                                                    <td>{item.vlr_unitario}</td>
                                                    <td>{item.prc_desconto}</td>
                                                    <td>{item.vlr_desconto}</td>
                                                    <td>{item.vlr_total}</td>
                                                    <td>{item.cod_combo_app}</td>
                                                    <td>{item.nro_ordem_item}</td>
                                                    <td>{item.ind_sku_corte}</td>
                                                    <td>{item.tipo_envio}</td>
                                                </tr>
                                            )
                                        })
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>

                {/* Payload */}
                <Modal size="xl" show={(this.state.isModalOpen === 4 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}
                >
                    {/*    <Modal.Header>
                        <Modal.Title
                            style={{
                                color: "#77b935"
                                , fontFamily: "Barlow"
                                , fontSize: "18px"
                                , fontStyle: "Italic"
                            }}
                        >Informações do Payload do Pedido
                        </Modal.Title>

                        <button type="button"
                            style={{ background: "#77b935" }}
                            className="btn btn-secondary"
                            onClick={this.FecharModalParam}
                        >Retorna
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-control">
                            <table className="table table-bordered  table-striped table-sm "
                                cellspacing="0" width="100%"
                                style={{
                                    fontFamily: "Barlow", fontSize: "10px",
                                    color: "#36561e", height: "100px"

                                }}
                            >
                                <thead className="thead">
                                    <tr >

                                        <th>Cód Status</th>
                                        <th>Cód Sku</th>
                                        <th>Qtde Int.</th>
                                        <th>Qtde Und</th>
                                        <th>Vlr.Unit.</th>
                                        <th>Prc Dsct</th>
                                        <th>Vlr.Dsct</th>
                                        <th>Vlr.Total</th>
                                        <th>Cód Cmb App</th>
                                        <th>Nro Ord</th>
                                        <th>Ind Sku Corte</th>
                                        <th>Tpo Envio</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {(RegPayLoad.length === 0 ? <span> <br /><br />  &nbsp;&nbsp; &nbsp;&nbsp; "Não há Dados"</span>
                                        :
                                        RegPayLoad.map((item, i) => {
                                            return (
                                                <tr key={i}>

                                                    <td>{item.cod_linha}</td>
                                                    <td>{item.cod_sku}</td>
                                                    <td>{item.qtd_pedida_inteira}</td>
                                                    <td>{item.qtd_pedida_unidade}</td>
                                                    <td>{item.vlr_unitario}</td>
                                                    <td>{item.prc_desconto}</td>
                                                    <td>{item.vlr_desconto}</td>
                                                    <td>{item.vlr_total}</td>
                                                    <td>{item.cod_combo_app}</td>
                                                    <td>{item.nro_ordem_item}</td>
                                                    <td>{item.ind_sku_corte}</td>
                                                    <td>{item.tipo_envio}</td>
                                                </tr>
                                            )
                                        })
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>*/}
                </Modal>
                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 5 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </div >

        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario

        //       , LstTodosOrder: state.orderRedJS.todoslistaorder

        , LstOrder: state.orderRedJS.listaOrder || []
        , LstSttus: state.orderRedJS.listadataStatus
        , Lstitens: state.orderRedJS.listaItensPdd
        // , LstPayLoad: state.orderRedJS.listaPayLoad
        , redListaTdsRevendas: state.orderRedJS.ListaTdsRevendas


    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        logout
        // , GettodosPdd 
        , getDataTdsRevendas
        , GetPdd
        , PegaStatusPedido
        , PegaItensPedido
        , enviaOrderRegistros
        // ,PegapayloadPedido
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Order)